export default {
    login: {
        t01: 'Langue',
        t02: 'Netflix',
        t03: 'Veuillez entrer votre nom d\'utilisateur',
        t04: 'Veuillez entrer votre mot de passe',
        t05: 'Connexion',
        t06: 'S\'inscrire',
        t07: 'Veuillez entrer votre numéro de téléphone',
        t08: 'Confirmer le mot de passe',
        t09: 'Veuillez entrer le code d\'invitation',
        t10: 'S\'inscrire',
        t11: 'Veuillez confirmer votre mot de passe',
        t13: 'L’amour du cinéma peut vous permettre d’accumuler une richesse considérable sans même vous en rendre compte.',
        t14: 'Connexion réussie',
        t15: 'Les mots de passe ne correspondent pas',
        t16: 'Inscription réussie',
        t17: 'Erreur réseau',
        t18: 'La requête a expiré, veuillez vérifier votre connexion réseau'
    },
    cover_info: {
        t01: 'Commencer à gagner',
        t02: 'Recharger des pièces',
        t03: 'Retirer des pièces',
        t04: 'Certificats'
    },
    cont: {
        t01: 'Choisir la langue',
        t02: 'Tout',
        t03: 'En attente',
        t04: 'Terminé',
        t05: 'Gelé',
        t06: 'Mon solde',
        t07: 'Incomplet',
        t08: 'Nombre total de commandes',
        t09: 'Commission',
        t10: 'Commission gagnée',
        t11: 'Nombre de commandes',
        t12: 'Solde disponible',
        t13: 'Commencer à prendre des commandes',
        t14: 'Fonds du compte',
        t15: 'Soumettre une commande',
        t16: 'Toutes les commandes soumises',
        t17: 'Heure de la commande',
        t18: 'Numéro de commande',
        t19: 'Montant total de la commande',
        t21: 'Œuvre',
        t22: 'Acteur',
        t23: 'Commentaires sur l’œuvre',
        t24: 'Annuler',
        t25: 'Veuillez choisir une évaluation',
        t26: 'Soumission de commande terminée',
        t27: 'Commande acquise',
        t28: 'Succès de la prise de commande',
        t29: 'Échec de la prise de commande, veuillez réessayer plus tard!'
    },
    user: {
        t1: 'Code de parrainage',
        t2: 'Solde',
        t3: 'Solde disponible',
        t4: 'Gains totaux',
        t5: 'Retirer',
        t6: 'Historique des dépôts',
        t7: 'Historique des retraits',
        t8: 'Détails du compte',
        t9: 'Message',
        t10: 'Connecter une carte bancaire',
        t11: 'Changer le mot de passe',
        t12: 'Changer le mot de passe de retrait',
        t13: 'Inviter des amis',
        t14: 'Choisir la langue',
        t15: 'Se déconnecter',
        t16: 'Retirer',
        t17: 'Montant à retirer',
        t18: 'Nom du compte',
        t19: 'Numéro de téléphone',
        t20: 'Montant à retirer',
        t21: 'Retirer',
        t22: 'Entrez le montant à retirer',
        t23: 'Entrez votre mot de passe de fonds virtuels',
        t24: 'Montant total déposé',
        t25: 'Messages système',
        t26: 'Détails de la carte bancaire',
        t27: 'Liste des banques',
        t28: 'Nom de la banque',
        t29: 'Alias',
        t30: 'Numéro de carte bancaire',
        t31: 'Numéro de téléphone',
        t32: 'Confirmer les modifications',
        t33: 'Entrez le numéro de compte de votre carte bancaire et le code IFSC. Assurez-vous d\'entrer correctement votre nom et numéro de téléphone, car le montant déposé ne sera pas reçu si cela n\'est pas fait.',
        t34: 'Ancien mot de passe',
        t35: 'Nouveau mot de passe',
        t36: 'Confirmer le mot de passe',
        t37: 'Continuer',
        t38: 'N\'oubliez pas votre mot de passe. Si vous avez oublié votre mot de passe, veuillez contacter le service client.',
        t39: 'Copier le lien d\'invitation',
        t40: 'Invitez des amis pour obtenir plus d\'avantages',
        t41: 'Dépôt',
        t42: 'Confirmer',
        t43: 'Annuler',
        t44: 'Êtes-vous sûr de vouloir vous déconnecter ?',
        t45: 'Montant déposé',
        t46: 'Le dépôt a été effectué avec succès',
        t47: 'Vérification terminée',
        t48: 'En attente de vérification',
        t49: 'Montant total retiré',
        t50: 'Veuillez d\'abord définir votre mot de passe de retrait',
        t51: 'Entrez votre ancien mot de passe',
        t52: 'Entrez votre nouveau mot de passe',
        t53: 'Confirmer le mot de passe',
        t54: 'Les mots de passe entrés ne correspondent pas',
        t55: 'Copié',
        t56: 'Le montant de retrait ne peut pas être inférieur à 30',
        t57: 'Envoyé avec succès, redirection en cours',
        t58: 'Échec de la révision',
        t59: 'Définir un avatar',
        t60: 'Définir maintenant',
        t61: 'Paramétrage réussi',
        t62: 'Après l\'approbation du portefeuille, vous devez vous connecter pour retirer de l\'argent',
        t63: 'Retrait sur carte bancaire',
        t64: 'Retrait en USDT (taux 1:0.013)',
        t65: 'Numéro de compte bancaire',
        t66: 'Veuillez entrer le numéro de compte bancaire et le code IFSC de la carte bancaire que vous souhaitez lier, ainsi que votre nom complet et numéro de téléphone. Assurez-vous que toutes les informations sont exactes pour faciliter les transactions de paiement.',
        t67: 'Veuillez d\'abord lier votre carte bancaire',
        t68: 'Recharge utilisateur',
        t69: 'Utilisateur acceptant les commandes',
        t70: 'Commission subordonnée',
        t71: 'Retrait utilisateur',
        t72: 'Transfert dans Yebao',
        t73: 'Transfert hors Yebao',
        t74: 'Gains Yebao',
        t75: 'Commission de commande',
        t76: 'Le solde est inférieur à 30, impossible de continuer les transactions, veuillez contacter le service client',
        t77: 'Veuillez entrer le nom de la banque',
        t78: 'Veuillez entrer le numéro de compte bancaire',
        t80: 'Veuillez entrer votre nom complet',
        t81: 'Veuillez entrer votre numéro de téléphone',
        t82: 'Veuillez entrer le montant de retrait',
        t83: 'Copier',
        t84: 'Top 100 quotidien : Mondial',
        t85: 'Écouter',
        t86: 'Email',
        t87: 'Veuillez entrer votre email',
        t88: 'Code bancaire',
        t89: 'Veuillez entrer le code bancaire',
        t90: 'Virement bancaire',
        t91: '1. Aucun frais n’est facturé pour les retraits',
        t92: '2. Le retrait sera reçu avec succès dans les 10 à 15 minutes suivant la demande. Pour les retraits effectués en dehors des heures ouvrables, le crédit sera effectué aux prochaines heures ouvrables.'
    },
    movie: {
        t01: 'Films et émissions de télévision populaires',
        t02: 'Mot de passe des fonds',
        t03: 'Écart de commande',
        t04: 'Gestion des adresses on-chain',
        t05: 'Veuillez saisir',
        t06: 'Veuillez saisir l’adresse on-chain correcte ainsi que le réseau correspondant (p. ex. ERC20/TRC20/BTC), sinon le paiement/le transfert peut ne pas arriver ou entraîner une perte d’actifs.',
        t07: 'Retirer vers une adresse on-chain',
        t08: 'Veuillez ajouter',
        t09: 'Veuillez ajouter une adresse on-chain',
    },
    langType: '法语'
}
